import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomSelection, Report, SelectionAction } from '../../report';
import moment from 'moment';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';
import { ProviderListService } from '../../services/gate-services/provider-list.service';
import { GateReconciliationsReportService } from '../../services/gate-services/providers-reconciliation-report.service';
import { ProviderReconciliationFixStatusService } from '../../services/gate-services/provider-reconciliation-fix-status.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MerchantListService } from '../../services/gate-services/merchant-list.service';

@Component({
  selector: 'app-providers-reconciliations',
  templateUrl: './providers-reconciliations.component.html',
  styleUrls: ['./providers-reconciliations.component.scss'],
})
export class ProvidersReconciliationsComponent implements OnInit {
  displayTableColumns: { [key: string]: string } = {
    transactionRefNum: 'Transaction Reference',
    providerName: 'Provider',
    gateStatus: 'Gate Status',
    providerStatus: 'Provider Status',
    result: 'Result',
    merchantName: 'Merchant',
    createStr: 'Created At',
  };
  properties = [
    // 'reconciliationId',
    'transactionRefNum',
    'providerName',
    'gateStatus',
    'providerStatus',
    'result',
    'merchantName',
    'createStr',
  ];
  private allKey = { key: 'All', value: null };
  selectFilters = [
    {
      filterFieldName: 'gateStatus',
      filterDisplayName: 'Gate status',
      filterOptions: [
        this.allKey,
        { key: 'REDEEMED', value: 'REDEEMED' },
        { key: 'EXPIRED', value: 'EXPIRED' },
        { key: 'PENDING', value: 'PENDING' },
        { key: 'CANCELED', value: 'CANCELED' },
        { key: 'APPROVED', value: 'APPROVED' },
        { key: 'FAILED', value: 'FAILED' },
        { key: 'REFUNDED', value: 'REFUNDED' },
      ],
      defaultValue: null,
    },
    {
      filterFieldName: 'providerStatus',
      filterDisplayName: 'Provider status',
      filterOptions: [
        this.allKey,
        { key: 'REDEEMED', value: 'REDEEMED' },
        { key: 'EXPIRED', value: 'EXPIRED' },
        { key: 'PENDING', value: 'PENDING' },
        { key: 'CANCELED', value: 'CANCELED' },
        { key: 'APPROVED', value: 'APPROVED' },
        { key: 'FAILED', value: 'FAILED' },
      ],
      defaultValue: null,
    },
    {
      filterFieldName: 'result',
      filterDisplayName: 'Result',
      filterOptions: [
        this.allKey,
        { key: 'MATCH', value: 'MATCH' },
        { key: 'MISMATCH', value: 'MISMATCH' },
        { key: 'FIXED', value: 'FIXED' },
      ],
      defaultValue: null,
    },
    {
      filterFieldName: 'merchantId',
      filterDisplayName: 'Merchants',
      filterOptions: [this.allKey],
      defaultValue: null,
    },
    {
      filterFieldName: 'providerId',
      filterDisplayName: 'Providers',
      filterOptions: [this.allKey],
      defaultValue: null,
    },
  ];
  selectionModel = new SelectionModel<any>(true, []);
  selectionActions: SelectionAction[] = [
    {
      actionName: 'Make it Fixed',
      actionValue: 'FIXED',
      actionType: 'Button',
      actionClass: 'btn-outline-danger',
    },
  ];
  selectableRows: CustomSelection[] = [
    {
      colName: 'result',
      valueIn: ['MISMATCH'],
    },
  ];
  loading = false;
  prividerReconciliationData: any[] = [];
  merchants: any[] = [];
  providers: any[] = [];
  currentMerchant = null;
  actions = [];
  totalNumberOfRecords: number = 0;
  requestBody: Report = {};
  itemsPerPage: number = 10;
  loadingFillterData = false;

  constructor(
    public reconciliationService: GateReconciliationsReportService,
    public fixStatusService: ProviderReconciliationFixStatusService,
    private cdr: ChangeDetectorRef,
    private providerListService: ProviderListService,
    private merchantListService: MerchantListService,
    public dialog: MatDialog,
  ) {}

  async ngOnInit() {
    this.reconciliationService.activateLoader();
    await this.getMerchants();
    await this.getProviders();
    this.loadingFillterData = true;
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }

  mapRecordsToFilterOptions(Records: { id: string; name: string }[]) {
    return Records.map((rec) => {
      return { key: rec.name, value: rec.id };
    });
  }

  async getMerchants() {
    this.merchants = await this.merchantListService.getMerchantList();
    const arr = this.mapRecordsToFilterOptions(this.merchants);
    arr.unshift(this.allKey);
    this.selectFilters[3].filterOptions = arr;
  }
  async getProviders() {
    this.providers = await this.providerListService.getProviders();
    const arr = this.mapRecordsToFilterOptions(this.providers);
    arr.unshift(this.allKey);
    this.selectFilters[4].filterOptions = arr;
  }

  getCurrentPage(event: any) {
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }
  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    };
    this.updateTable();
  }
  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
    }
    await this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
  }
  async updateTable() {
    this.reconciliationService.activateLoader();
    this.reconciliationService
      .loader()
      .subscribe((val) => (this.loading = val));
    if (
      this.requestBody['filterOptions'] &&
      this.requestBody['filterOptions']['createdAt']
    ) {
      // @ts-ignore
      const { startDate, endDate } =
        this.requestBody['filterOptions']['createdAt'];
      this.requestBody.filterOptions.createdAt.from =
        moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
      this.requestBody.filterOptions.createdAt.to =
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    }
    if (this.requestBody['filterOptions'] && this.currentMerchant) {
      this.requestBody['filterOptions'] = {
        ...this.requestBody['filterOptions'],
        merchantId: this.currentMerchant.merchantId,
      };
    }
    this.reconciliationService.setParams(this.requestBody);
    const responseData = await this.reconciliationService.make();
    this.totalNumberOfRecords = responseData.totalNumberOfRows;
    this.prividerReconciliationData = responseData.result;
    this.cdr.detectChanges();
  }
  async selectionActionsCB(event: any) {
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: `The action you have chosen is irreversible.
         Are you sure you want to proceed?`,
          question: true,
        },
      });
      const r = await dialogRef.afterClosed().toPromise();
      if (!r) {
        return;
      }
      this.fixStatusService.setParams({
        id: event.selection.map((i: any) => i.reconciliationId),
      });
      await this.fixStatusService.make();
      this.selectionModel.clear();
      this.updateTable();
    } catch (err) {
      console.log(err);
    }
  }
}
